/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProjectShareRequest } from '../model/projectShareRequest';
import { ProjectShareTargetDto } from '../model/projectShareTargetDto';
import { ReferencedRulesetDto } from '../model/referencedRulesetDto';
import { SharedProjectDto } from '../model/sharedProjectDto';
import { TransferOwnershipRequest } from '../model/transferOwnershipRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MyCheckProjectShareControllerService {

    protected basePath = 'https://api.beta.planbic.de';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listMyCheckProjectShareRulesets(id: string, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ReferencedRulesetDto>>;
    public listMyCheckProjectShareRulesets(id: string, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReferencedRulesetDto>>>;
    public listMyCheckProjectShareRulesets(id: string, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReferencedRulesetDto>>>;
    public listMyCheckProjectShareRulesets(id: string, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling listMyCheckProjectShareRulesets.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling listMyCheckProjectShareRulesets.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReferencedRulesetDto>>('get',`${this.basePath}/workflows/definitions/${encodeURIComponent(String(id))}/project-shares/rulesets`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listMyCheckProjectShareTargets(id: string, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ProjectShareTargetDto>>;
    public listMyCheckProjectShareTargets(id: string, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProjectShareTargetDto>>>;
    public listMyCheckProjectShareTargets(id: string, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProjectShareTargetDto>>>;
    public listMyCheckProjectShareTargets(id: string, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling listMyCheckProjectShareTargets.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling listMyCheckProjectShareTargets.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ProjectShareTargetDto>>('get',`${this.basePath}/workflows/definitions/${encodeURIComponent(String(id))}/project-shares/targets`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public shareMyCheckWithProjects(body: ProjectShareRequest, projectId: number, id: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SharedProjectDto>>;
    public shareMyCheckWithProjects(body: ProjectShareRequest, projectId: number, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SharedProjectDto>>>;
    public shareMyCheckWithProjects(body: ProjectShareRequest, projectId: number, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SharedProjectDto>>>;
    public shareMyCheckWithProjects(body: ProjectShareRequest, projectId: number, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling shareMyCheckWithProjects.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling shareMyCheckWithProjects.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling shareMyCheckWithProjects.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<SharedProjectDto>>('post',`${this.basePath}/workflows/definitions/${encodeURIComponent(String(id))}/project-shares`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transferMyCheckOwnership(body: TransferOwnershipRequest, projectId: number, id: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SharedProjectDto>>;
    public transferMyCheckOwnership(body: TransferOwnershipRequest, projectId: number, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SharedProjectDto>>>;
    public transferMyCheckOwnership(body: TransferOwnershipRequest, projectId: number, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SharedProjectDto>>>;
    public transferMyCheckOwnership(body: TransferOwnershipRequest, projectId: number, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling transferMyCheckOwnership.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling transferMyCheckOwnership.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling transferMyCheckOwnership.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<SharedProjectDto>>('post',`${this.basePath}/workflows/definitions/${encodeURIComponent(String(id))}/project-shares/owner`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param targetProjectId 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unshareMyCheckFromProject(id: string, targetProjectId: number, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<SharedProjectDto>>;
    public unshareMyCheckFromProject(id: string, targetProjectId: number, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SharedProjectDto>>>;
    public unshareMyCheckFromProject(id: string, targetProjectId: number, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SharedProjectDto>>>;
    public unshareMyCheckFromProject(id: string, targetProjectId: number, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling unshareMyCheckFromProject.');
        }

        if (targetProjectId === null || targetProjectId === undefined) {
            throw new Error('Required parameter targetProjectId was null or undefined when calling unshareMyCheckFromProject.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling unshareMyCheckFromProject.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SharedProjectDto>>('delete',`${this.basePath}/workflows/definitions/${encodeURIComponent(String(id))}/project-shares/${encodeURIComponent(String(targetProjectId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
